import { gql } from '@apollo/client';

export const GET_BORROWED_TOOLS = gql`
  query BorrowedTools($date: ISO8601Date!) {
    borrowedTools {
      items {
        id
        name
        description
        primaryImageUrl
        pricePerDayCents
        city
        postalCode
        nextAvailableDate(date: $date)
        categories {
          id
          name
          code
        }
      }
      totalCount
    }
  }
`;
